export default __webpack_public_path__ + "static/media/115.900e7d6d.jpeg";